import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { media, colors } from '../../styles/base';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    animateHeightContainer: {
      minHeight: 115,
      padding: '10px 0',
      width: 600,
      [media.tablet]: {
        width: 450,
      },
      [media.mobile]: {
        minHeight: 130,
        padding: 0,
        width: '100%',
      },
    },
    animateHeightContainerShort: {
      padding: '10px 0',
      width: 600,
      [media.tablet]: {
        width: 450,
      },
      [media.mobile]: {
        padding: 0,
        width: '100%',
      },
    },
    borderBottom: {
      border: '0.5px solid #C3CAD6',
      height: 0.5,
      margin: '35px auto',
      width: 850,
      [media.tablet]: {
        margin: '35px auto',
        width: '95%',
      },
      [media.mobile]: {
        margin: '35px 15px',
      },
    },
    cityName: {
      color: '#323232',
      fontSize: 14,
    },
    comment: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    commentTitle: {
      color: '#0E1217',
      fontSize: 18,
      fontWeight: 'bold',
      padding: 10,
      textAlign: 'left',
      [media.mobile]: {
        fontSize: 16,
        paddingLeft: 0,
      },
    },
    expandButtonStyle: {
      marginTop: 10,
      minWidth: 30,
      padding: 5,
      [media.mobile]: {
        padding: '0 5px 0 0',
      },
    },
    expandButtonText: {
      color: '#0E1217',
      fontSize: 12,
      fontWeight: 'bold',
    },
    image: {
      borderRadius: 50,
      height: 60,
      width: 60,
    },
    ratingsContainer: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      [media.mobile]: {
        flexDirection: 'column',
        marginTop: 25,
        width: '100%',
      },
    },
    reviewContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '0 auto',
      width: 850,
      [media.tablet]: {
        width: 700,
      },
      [media.mobile]: {
        flexDirection: 'column',
        padding: '0 20px',
        width: '100%',
      },
    },
    reviewText: {
      WebkitBoxOrient: 'vertical',
      display: '-webkit-box',
      lineHeight: '20px',
      margin: 0,
      overflow: 'hidden',
      paddingLeft: 10,
      textAlign: 'left',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [media.mobile]: {
        paddingLeft: 0,
      },
    },
    savings: {
      color: colors.purplePrimary,
      fontSize: 14,
      fontWeight: 'bold',
      marginTop: 14,
      textAlign: 'left',
    },
    starBox: {
      paddingLeft: 10,
      [media.mobile]: {
        paddingLeft: 0,
      },
    },
    updateDate: {
      color: '#323232',
      fontSize: 14,
      textAlign: 'left',
    },
    userDetailsContainer: {
      marginLeft: 15,
      paddingTop: 8,
      textAlign: 'left',
    },
    userName: {
      color: '#0E1217',
      fontSize: 14,
      fontWeight: 'bold',
    },
  }),
);
export default styles;
